import { State } from './types';

const initialState: State = {
	topics: [],
	fetched: false,
	searchTerm: ''
};

export default initialState;
